import * as __WEBPACK_EXTERNAL_MODULE__variants_tv_js_3ba00c2d__ from "../../../variants/tv.js";
const radioGroupVariants = (0, __WEBPACK_EXTERNAL_MODULE__variants_tv_js_3ba00c2d__.tv)({
    slots: {
        radioGroup: 'relative flex flex-col items-start gap-1'
    },
    variants: {
        layout: {
            vertical: {},
            horizontal: {
                radioGroup: 'flex-row flex-wrap items-center justify-start gap-4'
            }
        }
    },
    compoundVariants: [],
    defaultVariants: {
        layout: 'vertical'
    }
});
export { radioGroupVariants };
